export const setFormStep = (payload: number) => ({
  type: 'SET_FORM_STEP',
  payload,
});

export const clearFormStages = (payload: boolean) => ({
  type: 'LOAD_INITIAL_STEPS',
  payload,
});
